import { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import compose from 'lodash/flowRight';
import DialogContentText from '@material-ui/core/DialogContentText';
import MaterialTextField from '@material-ui/core/TextField';
import ConfirmButton from '../confirm-button';
import { approveEventMemberMutation } from '../../apollo/events';

const EventApproveMemberButton = ({ member, approveEventMember }) => {
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState('');

  return (
    <ConfirmButton
      label="Approve"
      message="Approve Request"
      variant="contained"
      size="small"
      color="primary"
      onClick={() => {
        setSubmitting(true);
        approveEventMember({
          variables: {
            id: member.id,
            message
          }
        }).then(() => {
          setSubmitting(false);
        }).catch(() => {
          alert('An error occurred while submitting. Please try again.');
          setSubmitting(false);
        });
      }}
      disabled={submitting}
    >
      <DialogContentText>
        Approve {member.user.displayName}&lsquo;s request to join
      </DialogContentText>
      <MaterialTextField
        autoFocus
        id="message"
        label="Message to requester"
        fullWidth
        multiline
        rows={3}
        maxRows={20}
        variant="outlined"
        value={message}
        onChange={(e) => {
          setMessage(e.target.value);
        }}
      />
    </ConfirmButton>
  );
};

EventApproveMemberButton.propTypes = {
  member: PropTypes.object,
  approveEventMember: PropTypes.func
};

export default compose(
  graphql(approveEventMemberMutation, {
    name: 'approveEventMember'
  })
)(EventApproveMemberButton);